// src/api/referential/referential.ts
import { ENDPOINTS_REF } from "./endpoints";
import { useApiClient } from "../apiClients";
import type { TCodification, TCountry } from "../../models/referential/referential";

export const useReferentialApi = () => {
    // Le référentiel vit côté service "tilmicode"
    const api = useApiClient("ref");

    const getCodifications = async (): Promise<TCodification[]> => {
        const { data } = await api.get<TCodification[]>(ENDPOINTS_REF.GET_CODIFICATIONS);
        return data;
    };

    const getCountries = async (): Promise<TCountry[]> => {
        const { data } = await api.get<TCountry[]>(ENDPOINTS_REF.GET_COUNTRIES);
        return data;
    };

    return {
        getCodifications,
        getCountries,
    };
};
